module.exports = __webpack_public_path__ + "static/img/NL.fa66664b.svg";